<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t('cryptogramGenerator.card.actions') }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <div class="mb-2">
            <output-actions-menu
              :show-export="false"
              :can-send="canSend"
              :puzzle-id="model.id"
              success-key="cryptogramGenerator.alert.sendSuccess"
              error-key="cryptogramGenerator.alert.sendError"
            />
            <p
              v-if="!canSend"
              class="text-muted mb-0 mt-1 small"
              style="color: #6c757d !important"
            >
              {{ $t('cryptogramGenerator.sidebar.sendHint') }}
            </p>
          </div>
          <d-button @click.prevent="fillAllLines()" class="btn-dark btn-block">
            {{ $t('cryptogramGenerator.button.fillWords') }}
          </d-button>
          <d-button
            @click.prevent="cleanAllLines()"
            class="btn-danger btn-block mt-2"
          >
            {{ $t('cryptogramGenerator.button.clearGame') }}
          </d-button>
          <print-buttons :cryptogramName="model.name" />
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer
    class="border-top d-flex flex-column flex-xl-row justify-content-around"
  >
    <d-button
      @click="save"
      type="button"
      class="btn-primary mb-3 mb-xl-0 col-xl-5"
    >
      {{ $t('shared.actions.save') }}
    </d-button>
    <d-button class="btn-secondary text-white col-xl-5" @click="goBack">
      {{ $t('shared.actions.back') }}
    </d-button>
  </d-card-footer>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import OutputActionsMenu from '_shared/OutputActionsMenu.vue';
import PrintButtons from './PrintButtons.vue';
import {
  _CRYPTOGRAM_FILL_ALL_LINES_,
  _CRYPTOGRAM_CLEAR_ALL_ANSWERS_,
  MODEL,
} from './CryptogramModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  components: { OutputActionsMenu, PrintButtons },
  computed: {
    canSend() {
      return Boolean(
        this.$route.params.puzzleId && this.model && this.model.id,
      );
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    fillAllLines() {
      Events.$emit(_CRYPTOGRAM_FILL_ALL_LINES_);
    },
    cleanAllLines() {
      Events.$emit(_CRYPTOGRAM_CLEAR_ALL_ANSWERS_);
    },
    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.$emit('save', this.model);
    },
  },
};
</script>
